import { Utils, FONT_COLORS } from '../../shared';
const TEXT_SIZES = [25, 50, 75, 100, 200, 300];
const DEFAULT_TEXT_SIZE = 100;
const TEXT_ELEMENTS = ['p', 'span', 'label'];
const DEFAULT_TEXT_ELEMENT = 'p';
const TEXT_WEIGHTS = ['light', 'regular', 'bold'];
const DEFAULT_TEXT_WEIGHT = 'regular';
const TEXT_MARGINS = ['none', 'both', 'bottom', 'top'];
const DEFAULT_TEXT_MARGIN = 'both';
const DEFAULT_TEXT_COLOR = 'inherit';
const TEXT_DEFINITIONS = {
    25: {
        size: 10,
        lineHeight: 16,
    },
    50: {
        size: 11,
        lineHeight: 16,
    },
    75: {
        size: 12,
        lineHeight: 16,
    },
    100: {
        size: 14,
        lineHeight: 20,
    },
    200: {
        size: 16,
        lineHeight: 24,
    },
    300: {
        size: 18,
        lineHeight: 28,
    },
};
TEXT_SIZES.forEach((sizeToken) => {
    TEXT_DEFINITIONS[sizeToken].margin = Utils.getFontMargin(TEXT_DEFINITIONS[sizeToken].size, 0.75);
});
export { TEXT_SIZES, DEFAULT_TEXT_SIZE, TEXT_ELEMENTS, DEFAULT_TEXT_ELEMENT, TEXT_WEIGHTS, DEFAULT_TEXT_WEIGHT, TEXT_MARGINS, DEFAULT_TEXT_MARGIN, FONT_COLORS as TEXT_COLORS, DEFAULT_TEXT_COLOR, TEXT_DEFINITIONS, };
